import type { Transformer } from "@/types/workspace";
import { TransformerBase } from "./TransformerBase";

export function TransformerUnknown({
  data: _data,
  warning,
  error,
  onUpdate: _onUpdate,
}: {
  data: Transformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: Transformer) => void;
}) {
  const transformerWarning = warning || "This is an invalid transformer";

  return <TransformerBase warning={transformerWarning} error={error} />;
}
